import React, {useState, useEffect, useRef} from "react";
import {UPLOADING_STATUS} from "../constants";

import Box from "@mui/material/Box";
import FilesList from "./FilesList";
import FilesControls from "./FilesControls";
import {UploadButton} from "../atoms";


function Files({tissue, typeObj, versionModel}) {
	const [files, setFiles] = useState([]);
	const [isLoadingStarted, setIsLoadingStarted] = useState(false);
	const [isUploadButtonDisabled, setIsUploadButtonDisabled] = useState(true);
    const [status, setStatus] = useState(UPLOADING_STATUS.Initialization);
	const nextSerialRef = useRef(1);
	const getNextSerial = () => nextSerialRef.current++;

	useEffect(() => {
		const isUploadButtonDisabled =
			status === UPLOADING_STATUS.Loading ||
			status === UPLOADING_STATUS.Success ||
			files.length === 0;

		setIsUploadButtonDisabled(isUploadButtonDisabled);
	}, [status, files.length]);



	return (
		<Box sx={{padding: 1}} style={{paddingTop: '30px'}}>
		<FilesControls
			files={files}
			status={status}
			setFiles={setFiles}
			setStatus={setStatus}
			setIsLoadingStarted={setIsLoadingStarted}
			getNextSerial={getNextSerial}
		/>
			<FilesList
				files={files}
				status={status}
				tissue={tissue}
				typeObj={typeObj}
				versionModel={versionModel}
				isLoadingStarted={isLoadingStarted}
				setFiles={setFiles}
				setStatus={setStatus}
			/>
				<UploadButton
					uploadHandler={() => setIsLoadingStarted(true)}
					isUploadButtonDisabled={isUploadButtonDisabled}
				/>
		</Box>
	);
}

export default Files;
